export const GET_DOCTOR_APPOINTMENTS = "GET_DOCTOR_APPOINTMENTS";
export const LOGIN_USER = "LOGIN_USER";
export const GET_USERS = "GET_USERS";
export const CREATE_USER = "CREATE_USER";
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const GET_DISEASES = "GET_DISEASES";
export const GET_INVOICES = "GET_INVOICES";
export const GET_ACTS_PRICE_PER_INSURER = "GET_ACTS_PRICE_PER_INSURER";
export const GET_ACTS = "GET_ACTS";
export const CREATE_MUTATE_INVOICE = "CREATE_MUTATE_INVOICE";
